import commonAnalytics from 'top20common/distribution/services/analytics/common';

export default function(multianalytics) {
  let common = commonAnalytics(multianalytics);

  common.trackSubmitApplicationClicked = function(contactInfo) {
    common.trackEventOnProd(
      {
        action: 'Pre-application Created',
        properties: contactInfo
      },
      ['mixpanel']
    );
  };

  return {
    ...common
  };
}
